export var Microsoft365RestoreWorkload;
(function (Microsoft365RestoreWorkload) {
    Microsoft365RestoreWorkload["MICROSOFT_365_RESTORE_WORKLOAD_ONEDRIVE"] = "ONEDRIVE";
    Microsoft365RestoreWorkload["MICROSOFT_365_RESTORE_WORKLOAD_MAILBOX"] = "MAILBOX";
})(Microsoft365RestoreWorkload || (Microsoft365RestoreWorkload = {}));
